import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { TemplateOfferingDetailsMeetingRoom } from "../template_offering_details_meeting_room";
import { useLuminaryAnalytics } from "./luminary_analytics";
import { generalInfo, partnerConfig } from "./luminary_partner_config";

const Theme = lazyWithRetry(() => import("./luminary_theme"));

const faqs = [
  {
    question: "Can we eat in the rooms?",
    answer:
      "You may enjoy coffee, tea, or water in the room! Food and alcohol not permitted but you may enjoy then in the kitchen areas on the 3rd and 4th floors!",
  },

  {
    question: "Where do we throw out our garbage?",
    answer:
      "There are trash cans in the room! When you are done with your dishes, you can leave them in the kitchen sink. Thank you for keeping the room clean.",
  },
];

export function OfferingLuminaryMeetingRoom() {
  useLuminaryAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingDetailsMeetingRoom
        showAddress
        showDirections
        partnerConfig={partnerConfig}
        data={{
          faqs,
          generalInfo,
          description:
            "Luminary features eleven private conference rooms for meetings, including two Boardrooms. Our conference rooms include seating from 4-6 people. Our Boardrooms hold up to 15 and 25 respectively. All of our conference rooms are outfitted with wall-mounted flat screen TVs and whiteboards, perfect for presentations, meetings, and brainstorming sessions!",
        }}
      />
    </Fragment>
  );
}
